import React from "react";
import {isEmpty} from "es-toolkit/compat";
import RenderIf from "@/components/Global/RenderIf/RenderIf";
import TabHeader from "@/components/Global/Tabs/TabHeader";
import styles from "./HeaderWithTabs.module.scss";

export default function HeaderWithTabs({id = "", tabs = [], className = "px-2 py-4", children}) {
  const totalShowTabs = tabs.filter(tab => tab?.show).length;

  return (
    <>
      <div className={`row mx-0 ${className} align-items-center`}>
        <div className="col fw-semibold">{children}</div>
      </div>
      <RenderIf isTrue={!isEmpty(tabs) && totalShowTabs > 1}>
        <TabHeader id={id} scrollToTop={true} className={`${styles.header}`}>
          {tabs
            ?.filter(tab => tab.show)
            ?.map((tab, index) => {
              if (!tab.id) console.error("HeaderWithTabs: Tab id is required");
              if (!tab.label) console.error("HeaderWithTabs: Tab label is required");
              const isActive = tab.isActive !== undefined ? tab.isActive : index === 0;

              return (
                <TabHeader.Item
                  key={index}
                  id={tab.id || ""}
                  className={"py-3"}
                  isActive={isActive}
                  aria-label={tab.ariaLabel || ""}
                  onClick={() => {
                    tab.onClick && tab.onClick(tab.id);
                  }}>
                  <span
                    className="d-flex justify-content-center align-items-center gap-1"
                    dangerouslySetInnerHTML={{__html: tab.label || ""}}></span>
                </TabHeader.Item>
              );
            })}
        </TabHeader>
      </RenderIf>
    </>
  );
}
